import { VueDraggableNext } from 'vue-draggable-next'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  nuxtApp.vueApp.component('HtsDraggable', VueDraggableNext)
})
